jQuery(document).ready(function($) {

    $( ".bloc_paraphotos" ).each(function( index ) {

        var $bloc = $(this);
        var cibleParaPhoto = $bloc.find(".visuel")
        var texteParaPhoto = $bloc.find(".texte")

        if(cibleParaPhoto.length){
            gsap.from( cibleParaPhoto , {
                scale: 1.1,
                scrollTrigger: {
                    trigger: cibleParaPhoto,
                    start: 'top 100%',
                    end: 'top 0%',
                    scrub: 1,
                    markers: false
                }
            })
        }

        if(texteParaPhoto.length){
            gsap.from(texteParaPhoto, {
                opacity : 0,
                duration: .6,
                y: 100,
                ease: "power1.out",
                scrollTrigger: {
                    trigger: texteParaPhoto,
                    markers: false,
                    start: "top bottom"
                }

            });
        }


        var cibleLogoLeft = $bloc.find(".fadeInLeft")

        if(cibleLogoLeft.length){
            gsap.from( cibleLogoLeft , {
                opacity: 0,
                x: -100,
                scrollTrigger: {
                    trigger: cibleLogoLeft,
                    start: 'top 100%',
                    end: 'top 0%',
                    scrub: 1,
                    markers: false
                }
            })
        }

        var cibleLogoRight = $bloc.find(".fadeInRight")

        if(cibleLogoRight.length){
            gsap.from( cibleLogoRight , {
                opacity: 0,
                x: +100,
                scrollTrigger: {
                    trigger: cibleLogoRight,
                    start: 'top 100%',
                    end: 'top 0%',
                    scrub: 1,
                    markers: false
                }
            })
        }

        // Carousel des visuels (fonction factorisée dans 19_carousel.js)
        initPcCarousel($bloc);

    })

});
